module.exports = __webpack_public_path__ + "static/img/03ko.13faee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/03ko.jpg
// module id = LmyZ
// module chunks = 0